module.exports = __webpack_public_path__ + "img/water_economy.mars.ac8a3d6.png";